<form
  #form="ngForm"
  novalidate
>
  <nsp-text-input
    id="portName"
    name="portName"
    label="Port Name"
    [labelWidthPercentage]="33"
    [required]="isFieldRequired('portName')"
    [readonly]="isFieldReadOnly('portName')"
    [value]="operationalStore.portAndPosition?.()?.portName?.value"
    [ngModel]="operationalStore.portAndPosition?.()?.portName?.value"
  />
  <re-lat-long-template
    id="portPosition"
    name="portPosition"
    title="Port position"
    [labelWidthPercentage]="33"
    [required]="isFieldRequired('portPosition')"
    [latLng]="operationalStore.portAndPosition?.()?.portPosition?.value"
    [ngModel]="operationalStore.portAndPosition?.()?.portPosition?.value"
  />
</form>
